import { useMemo } from 'react';

import { useTrainersGroupFilter } from '~/Hooks/useFilter/useTrainersGroupFilter';
import { useLocationsGroupFilter } from '~/Hooks/useFilter/useLocationsGroupFilter';
import { useEventCategoriesGroupFilter } from '~/Hooks/useFilter/useEventCategoriesGroupFilter';
import { AccessList, useHasAccess } from '~/Hooks';
import { useGroupFilter, FilterType, useEventStatusFilter } from '~/Hooks/useFilter';
import { useEventSportsCategoriesGroupFilter } from '~/Hooks/useFilter/useEventSportsCategoriesGroupFilter';

export const useCalendarFilter = () => {
  const { hasAccess } = useHasAccess();
  const filterType = FilterType.CALENDAR_FILTER;
  const trainersGroup = useTrainersGroupFilter({ filterType });
  const locationsGroup = useLocationsGroupFilter({ filterType });
  const categoriesGroup = useEventCategoriesGroupFilter({ filterType });
  const sportsCategoriesGroup = useEventSportsCategoriesGroupFilter({ filterType });
  const statusGroup = useEventStatusFilter({ filterType });

  const groups = useMemo(
    () => [
      ...(hasAccess(AccessList.EVENT_GROUP_FILTER_CATEGORIES) ? [categoriesGroup] : []),
      sportsCategoriesGroup,
      ...(hasAccess(AccessList.TRAINER_FILTER) ? [trainersGroup] : []),
      locationsGroup,
      statusGroup,
    ],
    [hasAccess, trainersGroup, locationsGroup, categoriesGroup, statusGroup],
  );

  return useGroupFilter({
    groups,
    filterType,
  });
};
